














































import {
  POSContact,
  POSProductCancelData,
  POSProductForContact,
  POSProductListForContact,
  POSProductType,
  POSProductUnpaidForContact,
  POSTicket,
} from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcPosContactDetailsColumn from '@pos/components/v2/pos-contact-details-column.vue';
import BpcPosContactDetailsUnpaidColumn from '@pos/components/v2/pos-contact-details-unpaid-column.vue';
import PosCancelProductModal from '@pos/components/v2/pos-cancel-product-modal.vue';
import PosContactDetailsBadgeColumn from '@pos/components/v2/pos-contact-details-badge-column.vue';

@Component({
  name: 'bpc-pos-contact-details',
  components: {
    BpcPosContactDetailsColumn,
    BpcPosContactDetailsUnpaidColumn,
    'bpc-pos-cancel-product-modal': PosCancelProductModal,
    'bpc-pos-contact-details-badge-column': PosContactDetailsBadgeColumn,
  },
})
export default class PosContactDetails extends Vue {
  // PROPS
  @Prop({ type: Object }) readonly contact: POSContact;
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Number, default: null }) readonly ticketId: number;
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;

  contactProducts: POSProductListForContact[] = [];
  listUnpaid: POSProductUnpaidForContact[] = [];
  productCancelData: POSProductCancelData = {
    posSessionId: this.posSessionId,
    destinyTicketId: this.ticketId,
    contactId: this.contact.id,
    productType: null,
    productId: null,
  };
  showCancelModal: boolean = false;
  changingQuantity: boolean = false;

  closeCancelProductModal() {
    this.showCancelModal = false;
    this.productCancelData.productType = null;
    this.productCancelData.productId = null;
    this.onCloseDetailContact();
  }

  onCancelProduct(data: { name: POSProductType; product: POSProductForContact }) {
    this.productCancelData.productType = data.name;
    this.productCancelData.productId = data.product.id;
    this.showCancelModal = true;
  }

  async onIncrementCredits(data: {
    name: POSProductType;
    product: POSProductForContact;
    increment: number;
  }) {
    this.changingQuantity = true;
    try {
      await this.$posService.incrementCredits(
        this.posSessionId,
        data.name,
        data.product.id,
        data.increment,
      );
      this.changingQuantity = false;
      if (data.increment > 0) {
        this.$bpcMessage.showSuccessMessage({ text: 'global.subscription.success_credit_added' });
      } else {
        this.$bpcMessage.showSuccessMessage({
          text: 'global.subscription.success_credit_consumed',
        });
      }
    } catch (error) {
      this.changingQuantity = false;
    }
    this.loadContactProducts();
  }

  //FixMe : THis one is not optimal
  async loadContactProducts() {
    this.contactProducts = await this.$posService.getContactProducts(
      this.posSessionId,
      this.contact.id,
    );
    for (let i = 0; i < this.contactProducts.length; i++) {
      for (let j = 0; j < this.contactProducts[i].products.length; j++) {
        if (
          !this.contactProducts[i].products[j].paid &&
          this.contactProducts[i].products[j].invoice_id === null
        ) {
          this.listUnpaid.push({
            id: this.contactProducts[i].products[j].id,
            name: this.contactProducts[i].products[j].name,
            productType: this.contactProducts[i].name,
            validity_start_date: this.contactProducts[i].products[j].validity_start_date,
            validity_end_date: this.contactProducts[i].products[j].validity_end_date,
            event_start_date_time: this.contactProducts[i].products[j].event_start_date_time,
            event_end_date_time: this.contactProducts[i].products[j].event_end_date_time,
          });
        }
      }
    }
  }

  // DATA

  // COMPUTED

  // LIFECYCLE HOOKS
  async mounted() {
    await this.loadContactProducts();
  }

  // METHODS
  public onCloseDetailContact() {
    this.$emit('close-detail-contact');
  }

  public onAddToTicket(product: POSProductUnpaidForContact) {
    console.log('onAddToTicket', product);
    //Fixme : Add to ticket
  }

  onCheckoutTicket($event: POSTicket) {
    this.$emit('checkout-ticket', $event);
  }

  // WATCHERS
  @Watch('contact')
  async onContactChanged() {
    await this.onCloseDetailContact();
  }
}
